import React from "react";
import Paper from "material-ui/Paper";
import Typography from "material-ui/Typography";
import Table from "material-ui/Table";
import { TableHeaderColumn, TableHead, TableBody } from "material-ui/Table";
import { TableCell } from "material-ui/Table";
import { TableRow } from "material-ui/Table";
import Grid from "material-ui/Grid";

import { withStyles } from "material-ui/styles";
import styles from "./styles";
const DiscoveryTab = props => (
  <Grid container>
    {!props.hideDisclaimer && (
    <Grid item xs={12}>
      <Typography color="inherit" className={props.classes.disclaimer}>
        {props.translate("result_disclaimer")}
      </Typography>
    </Grid>
    )}
    <Grid item xs={12}>
      <Table className={props.classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell className={props.classes.discovery_col_header}>
              {props.translate("result_protocol_tab")}
            </TableCell>
            <TableCell className={props.classes.discovery_col_header}>
              {props.translate("result_host")}
            </TableCell>
            <TableCell className={props.classes.discovery_col_header}>
              {props.translate("result_ip")}
            </TableCell>
            <TableCell className={props.classes.discovery_col_header}>
              {props.translate("result_mac")}
            </TableCell>
            <TableCell className={props.classes.discovery_col_header}>
              {props.translate("result_port")}
            </TableCell>
            <TableCell className={props.classes.discovery_col_header}>
              {props.translate("result_system")}
            </TableCell>
            <TableCell className={props.classes.discovery_col_header}>
              {props.translate("result_poe_device")}
            </TableCell>
            <TableCell className={props.classes.discovery_col_header}>
              {props.translate("result_model")}
            </TableCell>
            <TableCell className={props.classes.discovery_col_header}>
              {props.translate("result_vlan_info")}
            </TableCell>
            <TableCell className={props.classes.discovery_col_header}>
              {props.translate("result_capabilities")}
            </TableCell>
          </TableRow>
        </TableHead>
      </Table>
      <div className={props.classes.div_table2}>
        <Table className={props.classes.table} aria-label="simple table">
          <TableBody>
            {props.subtestStatsResults &&
            props.subtestStatsResults.discovery &&
            props.subtestStatsResults.discovery.length
              ? props.subtestStatsResults.discovery.map((item, k) => {
                  return (
                    <TableRow key={k}>
                      <TableCell
                        className={props.classes.discovery_col}
                        //align="center"
                      >
                        {item.protocol ? item.protocol : "--"}
                      </TableCell>
                      <TableCell
                        className={props.classes.discovery_col}
                        //align="center"
                      >
                        {item.hostname ? item.hostname : "--"}
                      </TableCell>
                      <TableCell
                        className={props.classes.discovery_col}
                        //align="center"
                      >
                        {item.ipaddress ? item.ipaddress : "--"}
                      </TableCell>
                      <TableCell
                        className={props.classes.discovery_col}
                        //align="center"
                      >
                        {item.macaddress ? item.macaddress : "--"}
                      </TableCell>
                      <TableCell
                        className={props.classes.discovery_col}
                        //align="center"
                      >
                        {item.portname ? item.portname : "--"}
                      </TableCell>
                      <TableCell
                        className={props.classes.discovery_col}
                        //align="center"
                      >
                        {item.systemdescription ? item.systemdescription : "--"}
                      </TableCell>
                      <TableCell
                        className={props.classes.discovery_col}
                        //align="center"
                      >
                        {item.poedevicetype ? item.poedevicetype : "--"}
                      </TableCell>
                      <TableCell
                        className={props.classes.discovery_col}
                        //align="center"
                      >
                        {item.model ? item.model : "--"}
                      </TableCell>
                      <TableCell
                        className={props.classes.discovery_col}
                        //align="center"
                      >
                        {item.vlan ? item.vlan : "--"}
                      </TableCell>
                      <TableCell
                        className={props.classes.discovery_col}
                        //align="center"
                      >
                        {item.hostcapabilities ? item.hostcapabilities : "--"}
                      </TableCell>
                    </TableRow>
                  );
                })
              : null}
          </TableBody>
        </Table>
      </div>
    </Grid>
  </Grid>
);
export default withStyles(styles)(DiscoveryTab);



// WEBPACK FOOTER //
// ./src/components/common/results/views/stats/discoveryTab.js